import { createTheme } from '@mantine/core';

export const theme = createTheme({
  fontFamily: '"Inter", "Dosis", ui-sans-serif, system-ui, sans-serif',
  headings: { fontFamily: '"Dosis", ui-sans-serif, system-ui, sans-serif', fontWeight: '700' },
  primaryColor: 'brand',
  primaryShade: { light: 8, dark: 6 },
  defaultRadius: 'md',
  colors: {
    brand: [
      '#f4f3ff',
      '#e9e7ff',
      '#d3d0ff',
      '#bbb6ff',
      '#a59eff',
      '#8f87ff',
      '#6f67e8',
      '#5b53d4',
      '#453db5',
      '#2e297a',
    ],
    ink: [
      '#f4f7fb',
      '#e9eef6',
      '#cfd9e8',
      '#b2c2dc',
      '#98acd0',
      '#7f95c4',
      '#6378ab',
      '#4c5d85',
      '#344158',
      '#101524',
    ],
  },
  components: {
    Button: {
      defaultProps: {
        fw: 600,
      },
    },
  },
});
